import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";
import { Logo } from "../../components/Logo";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { setUser } = useAuth();
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data);
            toast.success("Welcome back!");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err, "Login failed"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#080C14] px-4 grid-bg" data-testid="admin-login-page">
            <div className="glow-card w-full max-w-md rounded-3xl p-8 sm:p-10">
                <div className="flex justify-center"><Logo compact /></div>
                <h1 className="mt-6 text-center font-display text-2xl font-bold text-white">Admin Login</h1>
                <p className="mt-1 text-center text-sm text-slate-500">Manage blogs & leads</p>
                <form onSubmit={submit} className="mt-8 space-y-4">
                    <input
                        type="email"
                        required
                        data-testid="admin-email-input"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none focus:border-cyan-500/60"
                    />
                    <input
                        type="password"
                        required
                        data-testid="admin-password-input"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none focus:border-cyan-500/60"
                    />
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-button"
                        className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 px-6 py-3.5 text-sm font-semibold text-white disabled:opacity-60"
                    >
                        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
                        Sign In
                    </button>
                </form>
                <Link to="/" data-testid="admin-back-home-link" className="mt-6 block text-center text-xs text-slate-500 hover:text-cyan-300">
                    ← Back to website
                </Link>
            </div>
        </div>
    );
}
